import styled, { css } from 'styled-components'

export const ProfileTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  color: #555;
`

export const ProfileBox = styled.div`
  background: #ffffff;
  padding: 32px;
  display: flex;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;

  p {
    position: absolute;
    margin-top: 1px;
  }

  @media (max-width: 1170px) {
    flex-direction: column;

    .col-3 {
      display: block;
    }
  }
`

export const Collunm = styled.div`
  .collunm-1,
  .collunm-2,
  .collunm-3,
  .collunm-4,
  .collunm-5,
  .collunm-6,
  .collunm-7,
  .collunm-8,
  .collunm-9,
  .collunm-10,
  .collunm-11,
  .collunm-12 {
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
  }

  @media (min-width: 800px) {
    .collunm-1,
    .collunm-2,
    .collunm-3,
    .collunm-4,
    .collunm-5,
    .collunm-6,
    .collunm-7,
    .collunm-8,
    .collunm-9,
    .collunm-10,
    .collunm-11,
    .collunm-12 {
      float: left;
    }
    .collunm-12 {
      width: 100%;
    }
    .collunm-11 {
      width: 91.66666667%;
    }
    .collunm-10 {
      width: 83.33333333%;
    }
    .collunm-9 {
      width: 75%;
    }
    .collunm-8 {
      width: 66.66666667%;
    }
    .collunm-7 {
      width: 58.33333333%;
    }
    .collunm-6 {
      width: 50%;
    }
    .collunm-5 {
      width: 41.66666667%;
    }
    .collunm-4 {
      width: 33.33333333%;
    }
    .collunm-3 {
      width: 25%;
    }
    .collunm-2 {
      width: 16.66666667%;
    }
    .collunm-1 {
      width: 8.33333333%;
    }
  }
`

export const ProfileBoxFooter = styled.div`
  margin: 10px 0 20px 0;

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }
`

export const Button = styled.button`
  ${({ theme }) => css`
    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    padding: 12px 16px;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &:hover {
      background: #a71e26;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: $MEDIA-IPAD) {
      font-size: 14px;
    }

    &.button-outline {
      background: transparent;
      border: 2px solid ${theme.colors.primary};
      color: ${theme.colors.primary};

      &:hover {
        border-color: #4a4a4a;
        color: #4a4a4a;
      }

      &:disabled {
        color: #7b7b7b;
        border-color: #7b7b7b;
        cursor: initial;
      }
    }

    @media (max-width: 800px) {
      & + .button {
        margin-left: 0;
        margin-top: 8px;
      }
    }
  `}
`
